import { Instagram, Facebook, Phone, MapPin, BookOpen } from "lucide-react";
import { SITE } from "@/lib/site-config";

export default function Footer() {
  return (
    <footer
      data-testid="site-footer"
      className="bg-[#0F172A] text-slate-300"
    >
      <div className="container mx-auto grid gap-10 px-4 py-12 md:grid-cols-3 md:px-8 md:py-16">
        {/* Brand */}
        <div>
          <div className="flex items-center gap-3">
            <span className="flex h-10 w-10 items-center justify-center rounded-md bg-red-600 text-white">
              <BookOpen className="h-5 w-5" />
            </span>
            <span className="font-display text-lg font-extrabold text-white">
              {SITE.name}
            </span>
          </div>
          <p className="mt-4 max-w-xs text-[14px] leading-relaxed text-slate-400">
            {SITE.tagline} A 26-year legacy of disciplined coaching at Vitawa,
            Thane.
          </p>
        </div>

        {/* Contact */}
        <div>
          <h4 className="font-display text-sm font-bold uppercase tracking-[0.18em] text-white">
            Contact
          </h4>
          <ul className="mt-4 space-y-3 text-[14px]">
            <li className="flex items-start gap-3">
              <Phone className="mt-0.5 h-4 w-4 shrink-0 text-red-500" />
              <a
                href={`tel:${SITE.phoneTel}`}
                data-testid="footer-phone"
                className="hover:text-white"
              >
                {SITE.phoneDisplay}
              </a>
            </li>
            <li className="flex items-start gap-3">
              <MapPin className="mt-0.5 h-4 w-4 shrink-0 text-red-500" />
              <span data-testid="footer-address">{SITE.address}</span>
            </li>
          </ul>
        </div>

        {/* Social */}
        <div>
          <h4 className="font-display text-sm font-bold uppercase tracking-[0.18em] text-white">
            Follow
          </h4>
          <div className="mt-4 flex items-center gap-3">
            <SocialBtn
              href={SITE.instagramUrl}
              label="Instagram"
              testid="footer-instagram"
              icon={Instagram}
            />
            <SocialBtn
              href={SITE.facebookUrl}
              label="Facebook"
              testid="footer-facebook"
              icon={Facebook}
            />
          </div>
          <p className="mt-4 text-[12px] text-slate-500">
            Social links will be activated soon.
          </p>
        </div>
      </div>

      <div className="border-t border-white/10 py-5">
        <div className="container mx-auto flex flex-col items-center justify-between gap-2 px-4 text-[12px] text-slate-500 md:flex-row md:px-8">
          <span data-testid="footer-copyright">
            © {new Date().getFullYear()} Gurukul Classes. All rights reserved.
          </span>
          <span>Vitawa, Thane • Estd. 2000</span>
        </div>
      </div>
    </footer>
  );
}

function SocialBtn({ href, label, icon: Icon, testid }) {
  return (
    <a
      href={href || "#"}
      data-testid={testid}
      onClick={(e) => {
        if (!href || href === "#") e.preventDefault();
      }}
      aria-label={label}
      className="flex h-10 w-10 items-center justify-center rounded-md border border-white/15 bg-white/5 text-slate-300 transition-all hover:border-red-500/50 hover:bg-red-600/15 hover:text-white"
    >
      <Icon className="h-4 w-4" />
    </a>
  );
}
